import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const SaveReportModal = ({ onSave, onCancel, initialName, isSaving }) => {
    const [name, setName] = useState(initialName || 'Custom Data Analysis');

    useEffect(() => {
        if (initialName) setName(initialName);
    }, [initialName]);

    return ReactDOM.createPortal(
        <div className="overlay-fade-in" style={{
            position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)'
        }} onClick={onCancel}>
            <div className="modal-fade-in" style={{
                width: 450, background: '#fff', borderRadius: 12, padding: 32,
                boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
            }} onClick={e => e.stopPropagation()}>
                <div style={{ background: '#eef4ff', color: '#6366f1', width: 56, height: 56, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></svg>
                </div>
                <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#1a1c1d', textAlign: 'center' }}>Save Report</h2>
                <p style={{ fontSize: 13, color: '#6d7175', margin: '0 0 24px', textAlign: 'center' }}>
                    Give your custom report a name to save it to your dashboard.
                </p>

                <div style={{ marginBottom: 24 }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#6d7175', marginBottom: 8 }}>REPORT NAME</label>
                    <input
                        autoFocus
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="e.g. Sales by Region"
                        style={{
                            width: '100%', padding: '10px 14px', borderRadius: 8,
                            border: '1px solid #d2d2d2', fontSize: 14, outline: 'none',
                            transition: 'border-color 0.2s'
                        }}
                        onFocus={e => e.target.style.borderColor = '#6366f1'}
                        onBlur={e => e.target.style.borderColor = '#d2d2d2'}
                    />
                </div>

                <div style={{ display: 'flex', gap: 12 }}>
                    <button disabled={isSaving} onClick={onCancel} style={{ flex: 1, padding: '10px', borderRadius: 8, border: '1px solid #d2d2d2', background: '#fff', color: '#1a1c1d', fontWeight: 600, fontSize: 14, cursor: isSaving ? 'not-allowed' : 'pointer', opacity: isSaving ? 0.6 : 1 }}>
                        Cancel
                    </button>
                    <button disabled={isSaving || !name.trim()} onClick={() => onSave(name)} style={{
                        flex: 1, padding: '10px', borderRadius: 8, border: 'none',
                        background: '#6366f1', color: '#fff', fontWeight: 600,
                        fontSize: 14, cursor: (isSaving || !name.trim()) ? 'not-allowed' : 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        {isSaving ? <div className="dots-loading"><span></span><span></span><span></span></div> : 'Save Report'}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default SaveReportModal;
